import { Inventory } from '@/network/RestApi';

export interface InventoryItem {
  id: number;
  templateId: number;
  slotType?: string;
  slotIndex: number | null;
  quantity: number;
  upgradeLevel: number;
  options?: unknown;
}

export class InventorySystem {
  items: InventoryItem[] = [];
  charId = 0;

  setChar(id: number) { this.charId = id; }

  async refresh(): Promise<InventoryItem[]> {
    if (!this.charId) return [];
    const r = await Inventory.list(this.charId) as { items?: InventoryItem[] };
    this.items = r.items ?? [];
    return this.items;
  }

  async equip(itemId: number, slot: string) {
    if (!this.charId) return;
    await Inventory.equip(this.charId, { itemId, slot });
    await this.refresh();
  }

  async unequip(itemIdOrSlot: number | string) {
    if (!this.charId) return;
    if (typeof itemIdOrSlot === 'number') {
      await Inventory.unequip(this.charId, { itemId: itemIdOrSlot });
    } else {
      await Inventory.unequip(this.charId, { slot: itemIdOrSlot });
    }
    await this.refresh();
  }

  async sell(itemId: number, quantity?: number) {
    if (!this.charId) throw new Error('no character');
    const resp = await Inventory.sell(this.charId, { itemId, quantity });
    await this.refresh();
    return resp;
  }
}

export const inventory = new InventorySystem();
